import React, { useEffect, useState } from 'react';
import './MainContent.css';
import heroImage from '../images/hero-image.png';
import { Link } from "react-router-dom";

const MainContent = () => {
  const [postsRecientes, setPostsRecientes] = useState([]);

  useEffect(() => {
    fetch("/api/posts")
      .then((res) => res.json())
      .then((data) => {
        setPostsRecientes(data.slice(0, 3));
      })
      .catch((error) => {
        console.error("Error cargando noticias recientes:", error);
      });
  }, []);

  return (
    <main className="main-container">

      <section
        className="hero-section"
        style={{
          backgroundImage: `url(${heroImage})`
        }}
      >
        <div className="hero-overlay">
          <div className="hero-content">
            <span className="hero-badge">🟢 Servidor Operativo</span>

            <h1>
              Vive tu historia en
              <span> Club Oficial RP</span>
            </h1>

            <p>
              Economía real, trabajos, policías,
              empresas, bandas y eventos semanales.
            </p>

            <div className="hero-buttons">
              <button className="btn-primary">
                ▶ Conectarse al Servidor
              </button>

              <button className="btn-secondary">
                💬 Entrar al Discord
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="stats-section">
        <div className="stat-card">
          <div className="stat-number">124/200</div>
          <div className="stat-title">Jugadores en línea</div>
          <div className="stat-desc">Conectados ahora</div>
        </div>

        <div className="stat-card">
          <div className="stat-number">18</div>
          <div className="stat-title">Policías activos</div>
          <div className="stat-desc">En servicio</div>
        </div>

        <div className="stat-card">
          <div className="stat-number">42</div>
          <div className="stat-title">Empresas registradas</div>
          <div className="stat-desc">Negocios activos</div>
        </div>

        <div className="stat-card">
          <div className="stat-number">99.9%</div>
          <div className="stat-title">Uptime</div>
          <div className="stat-desc">Este mes</div>
        </div>
      </section>

      <section className="dashboard-grid">
        <div className="dashboard-card">
          <div className="card-header">
            Noticias recientes
          </div>

          {postsRecientes.map((post) => (
            <Link
              to={`/noticias/${post.slug}`}
              className="news-item news-item-link"
              key={post.id}
            >
              <img
                src={post.imagenPortada}
                alt={post.titulo}
                className="news-thumb"
              />

              <div>
                <h3>{post.titulo}</h3>
                <p>{post.resumen || post.contenido?.substring(0, 80) + "..."}</p>
              </div>
            </Link>
          ))}
        </div>

        <div className="dashboard-card">
          <div className="card-header">
            Top Jugadores
          </div>

          <table className="ranking-table">
            <tbody>
              <tr>
                <td>#1</td>
                <td>AlexisRP</td>
                <td>320h</td>
              </tr>

              <tr>
                <td>#2</td>
                <td>Ferchoo</td>
                <td>280h</td>
              </tr>

              <tr>
                <td>#3</td>
                <td>ZetaRP</td>
                <td>275h</td>
              </tr>

              <tr>
                <td>#4</td>
                <td>Mati_Off</td>
                <td>250h</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="dashboard-card">
          <div className="card-header">
            Discord Oficial
          </div>

          <div className="discord-widget">
            <iframe
              src="https://discord.com/widget?id=455189362033033237&theme=dark"
              width="100%"
              height="400"
              allowTransparency="true"
              frameBorder="0"
              sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
              title="Discord Widget"
            />
          </div>
        </div>
      </section>
    </main>
  );
};

export default MainContent;